import filter from "../../assets/images/filter.svg";
import blueFilter from "../../assets/images/BlueFilterIcon.svg";
import { colNameMapping } from "./utils";

function DesignJobsHeader(colName, columnNameOnClick, selectedFields, frozenColumns) {
  const isFilterActivated =
    selectedFields && Object.keys(selectedFields)?.length && selectedFields[colName]?.length > 0;

  const isFrozen = frozenColumns?.includes(colName);

  return (
    <div className={`flex-display ${isFrozen ? "font-bold frozen-width" : ""}`}>
      <img
        src={isFilterActivated ? blueFilter : filter}
        alt="Column Filter"
        className="columnFilterIcon"
        onClick={(e) => columnNameOnClick(e, colName)}
      />
      <span className="columnFilterIcon">{colNameMapping[colName]}</span>
    </div>
  );
}

export default DesignJobsHeader;
